/*
*
* inizializzo epd animazione
*
*/




function anime_epd_init(){

/*    var anime_epd ={
        firstname: "pippo",
        dammiilnome:function(){
            return this.firstname+"wwww";
        }
    };

    return anime_epd;*/

    var epd_svg = anime.timeline({
        autoplay: false,
        easing: 'easeInSine',
        duration:1000
    });

    epd_svg
    .add({
        targets: ['.epd_svg_icon'],                   
        opacity: 0,                 
        duration: 10,
    })
    .add({
        targets: ['.epd_svg_elem_center','.epd_svg_elem', '.epd_svg_label'],                   
        opacity: 0,                 
        duration: 10,
    })    
    .add({
        targets:'.epd_svg_elem_center',                   
        opacity: 1,   
        offset: 10,
        duration: 1000
        
    })
    .add({
        targets:'.epd_svg_label_6',                   
        opacity: 1,   
        offset: "-=200",
    })
    .add({
        targets:'.epd_svg_elem_1',                   
        opacity: 1,   
        offset: 250,
        duration:1000,
    })    
    .add({
        targets:'.epd_svg_elem_2',                   
        opacity: 1,   
        offset: 450,
        duration:1000,
    })
    .add({
        targets:'.epd_svg_elem_3',                   
        opacity: 1,   
        offset: 650,
    })
    .add({
        targets:'.epd_svg_elem_4',                   
        opacity: 1,   
        offset: 850,
        duration:1000,
    })
    .add({
        targets:'.epd_svg_elem_5',                   
        opacity: 1,   
        offset: 1050,
    })

    .add({
        targets:'.epd_svg_label_1',                   
        opacity: 1,   
        offset: "-=800",
    })
    .add({
        targets:'.epd_svg_icon_1',                   
        opacity: 1,   
        offset: "-=800",        
    })
    .add({
        targets:'.epd_svg_label_2',                   
        opacity: 1,   
        offset: "-=800",
    })
    .add({
        targets:'.epd_svg_icon_2',                   
        opacity: 1,   
        offset: "-=800",        
    })
    .add({
        targets:'.epd_svg_label_3',                   
        opacity: 1,   
        offset: "-=800",
    })
    .add({
        targets:'.epd_svg_icon_3',                   
        opacity: 1,   
        offset: "-=800",        
    })
    .add({
        targets:'.epd_svg_label_4',                   
        opacity: 1,   
        offset: "-=800",
    })
        .add({
        targets:'.epd_svg_icon_4',                   
        opacity: 1,   
        offset: "-=800",        
    })
    .add({
        targets:'.epd_svg_label_5',                   
        opacity: 1,   
        offset: "-=800",
    })
        .add({
        targets:'.epd_svg_icon_5',                   
        opacity: 1,   
        offset: "-=800",        
    })
    

    ; 
    jQuery('.epd_svg_elem_1').click(function(){
        //console.log('uno');
    });



    jQuery('.epd_svg_elem_2').click(function(){
      //console.log('due');
    });   

    return epd_svg;
}


/****************
* OROLOGIO
*****************/


function anime_orologio_init(){

    var orologio_svg = anime.timeline({
        autoplay: false,
        easing: 'easeInSine',
        duration:350,
        begin: function(anim){
           jQuery('#ej_orologio_svg').removeClass('noninmovimento');
        },
        complete: function(anim){
             jQuery('#ej_orologio_svg').addClass('noninmovimento');
        }
    });

    orologio_svg
    .add({
        targets: ['.orologio-elem'],                   
        opacity: 0,                 
        duration: 200,
    })

    .add({
        targets:'.orologio_24_2',                   
        opacity: 1,   
        //offset: 10,
        duration: 600
    }) 
    .add({
        targets:'.orologio_24_4',                   
        opacity: 1,   
        //offset: '+=5900',
        duration: 600
        
    },'-=400')
    .add({
        targets:'.orologio_24_w',                   
        opacity: 1,   
        //offset: '-=900',
       duration: 600
        
    },'-=400')
    .add({
        targets:'.orologio_24_e',                   
        opacity: 1,   
        //offset: '-=900',
        duration: 600
        
    },'-=400')
    .add({
        targets:'.orologio_24_a',                   
        opacity: 1,   
        //offset: '-=900',
        duration: 600
        
    },'-=400')
    .add({
        targets:'.orologio_24_r',                   
        opacity: 1,   
        //offset: '-=900',
        duration: 600
        
    },'-=400')
     .add({
        targets:'.orologio_24_freccia_1',                   
        opacity: 1,   
        //offset: '-=1400'
        duration: 600
        
    },'-=400')
         .add({
        targets:'.orologio_24_freccia_2',                   
        opacity: 1,   
        
        duration: 600
        
    },'-=400')
    .add({
        targets:'.orologio_24_freccia_3',                   
        opacity: 1,   
        
        duration: 600
        
    },'-=400')
    .add({
    targets:'.orologio_24_freccia_4',                   
        opacity: 1,   
        
        duration: 600
        
    },'-=400')
    .add({
    targets:'.orologio_24_linea',                   
        opacity: 1,   
        //offset: '-=1100'
    }) 
    .add({
        targets:[ '.orologio_24_2','.orologio_24_4','.orologio_24_w','.orologio_24_e','.orologio_24_a','.orologio_24_r'],                   
        opacity: 0,
        //duration:600,

    })
    .add({
        targets:'.orologio_24_freccia_1',                 
        opacity: 0,
        //offset:'-=500'
         duration: 600
        
    },'-=400')
    .add({
        targets:'.orologio_24_freccia_2',                 
        opacity: 0,
       // //offset:'-=800'
       duration: 600
        
    },'-=400')
    .add({
        targets:'.orologio_24_freccia_3',                 
        opacity: 0,
        //offset:'-=800'
        duration: 600
        
    },'-=400')
    .add({
        targets:'.orologio_24_freccia_4',                 
        opacity: 0,
        //offset:'-=800'
        duration: 600
        
    },'-=400')
    .add({
        targets:'.orologio_24_linea',                 
        opacity: 0,
        //offset:'-=900'
          duration: 600
        
    },'-=400')
   /* .add({
        targets:'#logo_sensitive',                 
        opacity: 1,
        duration:2000,
        offset: '-=900'
        
    })*/
        


    .add({
        targets:'.orologio-elem-1',                   
        opacity: 1,   
         //offset: '-=800',
         duration: 800
    })
    .add({
        targets:'.orologio-elem-2',                   
        opacity: 1,   
        //offset: '-=800',
        //duration: 400
         duration: 800
        
    },'-=600')
    .add({
        targets:'.orologio-elem-3',                   
        opacity: 1,   
        //offset: '-=800',
        //duration: 400
         duration: 800
        
    },'-=600')
    .add({
        targets:'.orologio-elem-4',                   
        opacity: 1,   
        //offset: '-=800',
        //duration: 400 
        duration: 800
        
    },'-=600')
    .add({
        targets:'.orologio-elem-5',                   
        opacity: 1,   
       // offset: '-=800',
        //duration: 400 
        duration: 800
        
    },'-=600')
    .add({
        targets:'.orologio-elem-6',                   
        opacity: 1,   
        //offset: '-=800',
        //duration: 400 
        duration: 800
        
    },'-=600')
    .add({
        targets:'.orologio-elem-7',                   
        opacity: 1,   
        //offset: '-=800',
        //duration: 400
         duration: 800
        
    },'-=600')
    .add({
        targets:'.orologio-elem-8',                   
        opacity: 1,   
        //offset: '-=800',
        //duration: 400
         duration: 800
        
    },'-=600')
    .add({
        targets:'.orologio-elem-9',                   
        opacity: 1,   
        //offset: '-=800',
        //duration: 400
         duration: 800
        
    },'-=600')
    .add({
        targets:'.orologio-elem-10',                   
        opacity: 1,   
        //offset: '-=800',
        //duration: 400
 duration: 800
        
    },'-=600')
    

    ; 
    /*jQuery('.epd_svg_elem_1').click(function(){
        console.log('uno');
    });*/



    /*jQuery('.epd_svg_elem_2').click(function(){
      console.log('due');
  });  */ 

    return orologio_svg;
}



/****************
* MANO
*****************/


function anime_mano_init_old(){

    var mano_svg = anime.timeline({
        autoplay: false,
        easing: 'easeInSine',
        duration:500
    });

    mano_svg
    .add({
        targets: '.mano-pollice',                   
        fill: 'rgba(255,255,255,1)',                      
        duration: 1000,
        offset:500,
    })  
        .add({
        targets: '.mano-pollice',                   
         fill: 'rgba(255,255,255,0)',                  
        duration: 500,
        offset: 1600,
    }) 
         .add({
        targets: '.mano-indice',                   
        fill: 'rgba(255,255,255,1)',                      
        duration: 1000,
        offset:1000,
    })  
        .add({
        targets: '.mano-indice',                   
         fill: 'rgba(255,255,255,0)',                  
        duration: 500,
        offset: 2100,
    }) 
         .add({
        targets: '.mano-medio',                   
        fill: 'rgba(255,255,255,1)',                      
        duration: 1000,
        offset:1500,
    })  
        .add({
        targets: '.mano-medio',                   
         fill: 'rgba(255,255,255,0)',                  
        duration: 500,
        offset: 2600,
    }) 
         .add({
        targets: '.mano-anulare',                   
        fill: 'rgba(255,255,255,1)',                      
        duration: 1000,
        offset:2000,
    })  
        .add({
        targets: '.mano-anulare',                   
         fill: 'rgba(255,255,255,0)',                  
        duration: 500,
        offset: 3100,
    })
                 .add({
        targets: '.mano-mignolo',                   
        fill: 'rgba(255,255,255,1)',                      
        duration: 1000,
        offset:2500,
    })  
        .add({
        targets: '.mano-mignolo',                   
         fill: 'rgba(255,255,255,0)',                  
        duration: 500,
        offset: 3600,
    })

   
    

    ; 
    /*jQuery('.epd_svg_elem_1').click(function(){
        console.log('uno');
    });*/



    /*jQuery('.epd_svg_elem_2').click(function(){
      console.log('due');
  });  */ 

    return mano_svg;
}


/****************
* MANO_2
*****************/


function anime_mano_init(){

    var mano_svg = anime.timeline({
        autoplay: false,
        easing: 'easeInSine',
        duration:500
    });

    mano_svg
    .add({
        targets: '.mano_scritta_1',                   
        fill: 'rgba(255,255,255,1)',                      
        duration: 1500,
        offset:500,
    })  
        .add({
        targets: '.mano_scritta_1',                   
         fill: 'rgba(255,255,255,0)',                  
        duration: 500,
        offset: 2100,
    }) 
         .add({
        targets: '.mano_scritta_2',                   
        fill: 'rgba(255,255,255,1)',                      
        duration: 1500,
        offset:1000,
    })  
        .add({
        targets: '.mano_scritta_2',                   
         fill: 'rgba(255,255,255,0)',                  
        duration: 500,
        offset: 2600,
    }) 
         .add({
        targets: '.mano_scritta_3',                   
        fill: 'rgba(255,255,255,1)',                      
        duration: 1500,
        offset:1500,
    })  
        .add({
        targets: '.mano_scritta_3',                   
         fill: 'rgba(255,255,255,0)',                  
        duration: 500,
        offset: 3100,
    }) 
         .add({
        targets: '.mano_scritta_4',                   
        fill: 'rgba(255,255,255,1)',                      
        duration: 1500,
        offset:2000,
    })  
        .add({
        targets: '.mano_scritta_4',                   
         fill: 'rgba(255,255,255,0)',                  
        duration: 500,
        offset: 3600,
    })
                 .add({
        targets: '.mano_scritta_5',                   
        fill: 'rgba(255,255,255,1)',                      
        duration: 1500,
        offset:2500,
    })  
        .add({
        targets: '.mano_scritta_5',                   
         fill: 'rgba(255,255,255,0)',                  
        duration: 500,
        offset: 4100,
    })

   
    

    ; 
    /*jQuery('.epd_svg_elem_1').click(function(){
        console.log('uno');
    });*/



    /*jQuery('.epd_svg_elem_2').click(function(){
      console.log('due');
  });  */ 

/*
  jQuery('.mano-pollice').hover(function(){
        jQuery('.mano_scritta_1').css('fill','rgba(255,255,255,1)');
        console.log('aaaaaaaaaa');

  },
    function(){
          jQuery('.mano_scritta_1').css('fill','rgba(255,255,255,0)');
    });

    jQuery('.mano-indice').hover(function(){
        jQuery('.mano_scritta_2').css('fill','rgba(255,255,255,1)');
        console.log('aaaaaaaaaa');

  },
    function(){
          jQuery('.mano_scritta_2').css('fill','rgba(255,255,255,0)');
    });

      jQuery('.mano-medio').hover(function(){
        jQuery('.mano_scritta_3').css('fill','rgba(255,255,255,1)');
        console.log('aaaaaaaaaa');

  },
    function(){
          jQuery('.mano_scritta_3').css('fill','rgba(255,255,255,0)');
    });

        jQuery('.mano-anulare').hover(function(){
        jQuery('.mano_scritta_4').css('fill','rgba(255,255,255,1)');
        console.log('aaaaaaaaaa');

  },
    function(){
          jQuery('.mano_scritta_4').css('fill','rgba(255,255,255,0)');
    });

          jQuery('.mano-mignolo').hover(function(){
        jQuery('.mano_scritta_5').css('fill','rgba(255,255,255,1)');
        console.log('aaaaaaaaaa');

  },
    function(){
          jQuery('.mano_scritta_5').css('fill','rgba(255,255,255,0)');
    });
    
  */

    return mano_svg;
}